import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function FitnessGymSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("fitnessGym.title")}</title>
        <meta name="keywords" content={t("fitnessGym.keywords")} />
        <meta name="description" content={t("fitnessGym.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#2a2238]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/fitness-gym-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_3%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#1a1428]/92 via-[#1a1428]/72 to-[#1a1428]/62" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("fitnessGym.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("fitnessGym.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("fitnessGym.knowledgeBase.rootLabel")}
        rootColor="#7c3aed"
        treeTranslationKey="fitnessGym.knowledgeBase.tree"
        i18nPrefix="fitnessGym.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="fitnessGym"
        images={{
          painPoints: "/solutions/fitness-gym-pain.jpeg",
          solutions: "/solutions/fitness-gym-solutions.jpeg",
          cta: "/solutions/fitness-gym-solutions.jpeg",
        }}
        imagesPos={{
          painPoints: "50% 22%",
          solutions: "50% 26%",
          cta: "50% 8%",
        }}
      />
    </>
  );
}
